var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.commentStyle,on:{"click":function($event){$event.stopPropagation();return _vm.Gocomment(_vm.isClick)}}},[_c('i',{staticClass:"icon"}),(_vm.count !== 0)?_c('span',{staticClass:"desc"},[_vm._v(_vm._s(_vm.count))]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21d5383b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/amount/comment.vue
// module id = null
// module chunks = 